'use client'

import { type FC, useEffect } from 'react'

import { useDeviceDetectorContext } from '../../../device-detector/context/deviceDetectorContext'
import { useProductPromotion } from '../../../product-page/components/ProductDescription/ProductDescriptionPromotions/useProductPromotion'
import { useExperimentsContext } from '../ExperimentsContext'

import { useGetFreeGiftPromotionsExperiment } from './useGetFreeGiftPromotionsExperiment'

export const ExperimentFreeGiftPromotionActivation: FC = () => {
  const { isMobile } = useDeviceDetectorContext()
  const { addExperimentKeysForActivation } = useExperimentsContext()
  const { isEnabled, name: experimentName } =
    useGetFreeGiftPromotionsExperiment(isMobile)
  const { hasPromotion } = useProductPromotion()

  useEffect(() => {
    if (!hasPromotion || !isEnabled) {
      return
    }
    addExperimentKeysForActivation(experimentName)

    return undefined
  }, [addExperimentKeysForActivation, experimentName, hasPromotion, isEnabled])

  return undefined
}
